<form
  (ngSubmit)="onSubmit()"
  [formGroup]="customerSelectionForm"
>
  <span class="searchLabel">{{
      'asm.customerSearch.searchTerm.label' | cxTranslate
    }}</span>
  <label>
    <input
      required="true"
      #searchTerm
      type="text"
      formControlName="searchTerm"
      [attr.aria-label]="
        'asm.customerSearch.searchTerm.label' | cxTranslate
      "
      placeholder="{{
        'asm.customerSearch.searchTerm.label' | cxTranslate
      }}"
      (keydown.arrowdown)="focusFirstItem($any($event))"
      (keydown.end)="setSelectionEnd($any($event))"
    />

    <div *ngIf="searchResults | async as results" #resultList>
      <div
        *ngIf="
          isNoResultMessageInfoVisible(results, searchByCustomer, searchTerm)
        "
        class="message message-info selection-message-info"
      >
        <div class="message-content">
          <div class="message-header">
            <span class="message-icon">
              <cx-icon
                class="icon fas fa-info-circle"
                ng-reflect-type="INFO"
              ></cx-icon>
            </span>
            <span class="message-text"
            >{{ 'asm.customerSearch.noCustomerMatchResult' | cxTranslate }}
            </span>
            <span
              #createCustomerLink
              class="linkStyleLabel"
              (click)="createCustomer()"
            >
              {{ 'asm.customerSearch.createCustomer' | cxTranslate }}
            </span>
          </div>
        </div>
      </div>
      <div
        *ngIf="isSearchResultsVisible(results, searchByCustomer)"
        class="asm-results"
      >
        <button
          #searchResultItem
          *ngFor="let result of results.entries; let i = index"
          [tabindex]="activeFocusedButtonIndex === i ? 0 : -1"
          [attr.aria-selected]="activeFocusedButtonIndex === i"
          [class.active]="activeFocusedButtonIndex === i"
          (keydown.arrowup)="focusPreviousChild($any($event))"
          (keydown.arrowdown)="focusNextChild($any($event))"
          (keydown.arrowright)="focusInputText($any($event))"
          (keydown.arrowleft)="focusInputText($any($event))"
          (keydown.enter)="selectCustomerFromList($any($event), result)"
          (keydown.escape)="closeResults($any($event))"
          (keydown.home)="focusInputText($any($event))"
          (keydown.end)="focusInputText($any($event))"
          (click)="selectCustomerFromList($any($event), result)"
        >
          <div class="result-name">{{ result.name }}</div>
          <div class="result-id">
            <span>{{ result.uid }}</span>
          </div>
        </button>
      </div>
    </div>

    <div class="asm-results" *ngIf="isLoading && searchByCustomer">
      <cx-dot-spinner
        aria-hidden="false"
        [attr.aria-label]="'common.loading' | cxTranslate"
      ></cx-dot-spinner>
    </div>
  </label>
  <span class="searchLabel">{{
      'asm.customerSearch.orderID' | cxTranslate
    }}</span>

  <label>
    <input
      required="true"
      #searchOrder
      type="text"
      formControlName="searchOrder"
      [attr.aria-label]="'asm.customerSearch.searchOrder.label' | cxTranslate"
      placeholder="{{ 'asm.customerSearch.searchOrder.label' | cxTranslate }}"
      (keydown.arrowdown)="focusFirstItem($any($event))"
      (keydown.end)="setOrderSearchSelectionEnd($any($event))"
    />
    <div *ngIf="searchResults | async as results" #resultList>
      <div
        *ngIf="
          isNoResultMessageInfoVisible(results, searchByOrder, searchOrder)
        "
        class="message message-info selection-message-info"
      >
        <div class="message-content">
          <div class="message-header">
            <span class="message-icon">
              <cx-icon
                class="icon fas fa-info-circle"
                ng-reflect-type="INFO"
              ></cx-icon>
            </span>
            <span class="message-text">
              {{ 'asm.customerSearch.noOrderMatchResult' | cxTranslate }}
            </span>
          </div>
        </div>
      </div>
      <div
        *ngIf="isSearchResultsVisible(results, searchByOrder)"
        class="asm-results"
      >
        <button
          #searchResultItem
          *ngFor="let result of results.entries; let i = index"
          [tabindex]="activeFocusedButtonIndex === i ? 0 : -1"
          [attr.aria-selected]="activeFocusedButtonIndex === i"
          [class.active]="activeFocusedButtonIndex === i"
          (keydown.arrowup)="focusPreviousChild($any($event))"
          (keydown.arrowdown)="focusNextChild($any($event))"
          (keydown.arrowright)="focusOrderSearchInputText($any($event))"
          (keydown.arrowleft)="focusOrderSearchInputText($any($event))"
          (keydown.enter)="selectCustomerFromList($any($event), result)"
          (keydown.escape)="closeOrderSearchResults($any($event))"
          (keydown.home)="focusOrderSearchInputText($any($event))"
          (keydown.end)="focusOrderSearchInputText($any($event))"
          (click)="selectCustomerFromList($any($event), result)"
        >
          <div class="result-name">{{ searchOrder.value }}</div>
          <div class="result-id">
            <span>{{ result.name }}</span>
          </div>
        </button>
      </div>
    </div>

    <div class="asm-results" *ngIf="isLoading && searchByOrder">
      <cx-dot-spinner
        aria-hidden="false"
        [attr.aria-label]="'common.loading' | cxTranslate"
      ></cx-dot-spinner>
    </div>
  </label>

  <button
    type="submit"
    [class.active]="selectedCustomer"
    [disabled]="!selectedCustomer"
  >
    {{ 'asm.customerSearch.submit' | cxTranslate }}
  </button>
</form>
